exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#middle.svelte-alhbsv{display:flex;justify-content:space-between;align-items:center;margin-top:40px}#actions.svelte-alhbsv{display:flex;justify-content:flex-end;flex-direction:column}.button__add-review-1eUR4v, .button__add-question-2Ioy7J{margin-top:5px}", ""]);
